/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from './View'
import { Divider } from './Divider'
import { Text } from '@components/atoms'

interface PropsType {
	title?: string
	renderTitle?: React.ReactNode
	leftHeaderAccessory?: JSX.Element
	rightHeaderAccessory?: React.ReactNode
}

export const BoxHeaderView = (props: PropsType) => {
	const title: string = props.title !== undefined ? props.title : ''

	return (
		<View css={style}>
			<View className="innerView">
				{props.renderTitle !== undefined ? (
					props.renderTitle
				) : (
					<Text className="title">{title}</Text>
				)}
				{props.leftHeaderAccessory && (
					<View className="leftAccssory">{props.leftHeaderAccessory}</View>
				)}
				<View className="rightAccessory mobile">
					{props.rightHeaderAccessory ?? null}
				</View>
			</View>
			<Divider style={{ marginBottom: 0 }} />
		</View>
	)
}

const style = css({
	position: 'relative',
	textAlign: 'left',

	'.innerView': {
		display: 'flex',
		alignItems: 'center',
		minHeight: '1.5rem',

		'.title': {
			margin: 0,
			marginTop: '0.5rem',
		},

		'.leftAccssory': {
			position: 'relative',
			marginLeft: '2rem',
		},

		'.rightAccessory': {
			position: 'absolute',
			display: 'flex',
			alignItems: 'center',
			height: '3.5rem',
			top: '1rem',
			bottom: 0,
			right: 0,
			margin: 'auto',

			'&.mobile': {
				display: 'block',
			},
		},
	},

	'.addAccessory': {
		display: 'none',
	},

	'@media (max-width: 900px)': {
		position: 'absolute',

		'.innerView': {
			'.title': {
				display: 'none',
			},

			'.leftAccssory': {
				display: 'none',
			},

			'.rightAccessory': {
				display: 'none',

				'&.mobile': {
					display: 'block',
					position: 'fixed',
					zIndex: 10,
					alignItems: 'center',
					top: 'calc(100vh - 11rem)',
					bottom: 0,
					right: '1.5rem',
					margin: 'auto',
				},
			},
		},
	},
})
